export default "/_next/static/images/winnersBg-5ad45a397c4dcfd13c9f297795b146b5.png";